import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Cell as CoreCell } from '@vds-core/tables';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import { withVDSManager } from '@vds/utilities';
import { colors } from '@vds/theme';
var propTypes = {
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop'])
};
var defaultProps = {
  viewport: 'desktop'
};

var Cell = function Cell(props) {
  var viewport = props.viewport;
  return /*#__PURE__*/React.createElement(CoreCell, _extends({}, props, {
    bodyConfig: BodyConfig,
    cellPadding: viewport === 'mobile' ? calculateRem(8, 12, 16, 0) : calculateRem(12, 32, 24, 0),
    colorConfig: colors,
    typescale: TypographyConfig.getTypescale()
  }));
};

Cell.propTypes = propTypes;
Cell.defaultProps = defaultProps;
export default withVDSManager(Cell);